import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Select from 'react-select';

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


// Styles
import { FormStyled, Row, Column } from '../../css/styles/form';
import { SelectStyled } from '../../css/styles/select';
import { Button } from '@material-ui/core';

const handleValidate = ({ name }) => {
  const errors = {};
  if (!name) errors.name = 'OBRIGATÓRIO';
  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  if (!props.partner) {
    await props.onCreation({ ...values });
  } else {
    await props.onUpdate({ ...values });
  }
  setSubmitting(false);
  resetForm();
};

const PartnerForm = props => {
  const { onDelete, onNew, onEdit, partner, partners, taxRegimes } = props;

  const handleExportExcel = () => {
    if (!partners || partners.length === 0) return;

    const data = partners.map(p => {
      const regime = taxRegimes?.find(tr => tr.uuid === p.taxRegimeUuid);

      return {
        NOME: p.name,
        CNPJ: p.cnpj,
        "REGIME TRIBUTÁRIO": regime ? `${regime.code} - ${regime.description}` : "",
        REPRESENTANTE: p.representative,
        EMAIL: p.email,
        TELEFONE: p.phone,
        CELULAR: p.cell_phone,
        "INSCRIÇÃO ESTADUAL": p.state_registration,
        "INSCRIÇÃO MUNICIPAL": p.municipal_registration,
        ENDEREÇO: p.address,
        BAIRRO: p.neighborhood,
        CIDADE: p.city,
        CEP: p.zip_code,
        UF: p.uf,
        OBSERVAÇÃO: p.observation,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Partners");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, "partners.xlsx");
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: partner ? partner.name : '',
        cnpj: partner ? partner.cnpj : '',
        taxRegimeUuid: partner ? partner.taxRegimeUuid : '',
        representative: partner ? partner.representative : '',
        email: partner ? partner.email : '',
        phone: partner ? partner.phone : '',
        cell_phone: partner ? partner.cell_phone : '',
        state_registration: partner ? partner.state_registration : '',
        municipal_registration: partner ? partner.municipal_registration : '',
        address : partner ? partner.address : '',
        neighborhood : partner ? partner.neighborhood : '',
        city : partner ? partner.city : '',
        zip_code : partner ? partner.zip_code : '',
        uf : partner ? partner.uf : '',
        observation : partner ? partner.observation : '',
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleReset,
        errors,
        touched,
        setFieldValue,
        isSubmitting,
        dirty,
      }) => (
        <FormStyled>
          <h1>NOVO FORNECEDOR OU CLIENTE</h1>

          <ul>
            <Row>
              <Column>
                <strong>NOME</strong>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.name && touched.name && <span>{errors.name}</span>}
              </Column>
            </Row>

            <Row>
              <Column>
                <strong>CNPJ OU CPF</strong>
                <input
                  id="cnpj"
                  name="cnpj"
                  type="text"
                  value={values.cnpj}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.cnpj && touched.cnpj && <span>{errors.cnpj}</span>}
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>REGIME TRIBUTÁRIO</strong>

                <Select
                  styles={SelectStyled}
                  id="taxRegimeUuid"
                  name="taxRegimeUuid"
                  placeholder="Selecione o regime tributário"
                  value={taxRegimes?.find(item => item.uuid === values.taxRegimeUuid)}
                  onChange={selectedOption => {
                    setFieldValue('taxRegimeUuid', selectedOption.uuid);
                  }}
                  options={taxRegimes || []}
                  getOptionLabel={item => `${item.code}` + " - " + `${item.description}`}
                  getOptionValue={item => item.uuid}
                  isSearchable
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando'}
                  noOptionsMessage={() => 'Nenhum dado encontrado'}
                />
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>INSCRIÇÃO ESTADUAL</strong>
                <input
                  id = "state_registration"
                  name = "state_registration"
                  type = "text"
                  value = {values.state_registration}
                  onChange = {handleChange}
                  onBlur = {handleBlur}
                />
              </Column>
              <Column>
                <strong>INSCRIÇÃO MUNICIPAL</strong>
                <input
                  id = "municipal_registration"
                  name = "municipal_registration"
                  type = "text"
                  value = {values.municipal_registration}
                  onChange = {handleChange}
                  onBlur = {handleBlur}
                />
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>REPRESENTANTE</strong>
                <input
                  id="representative"
                  name="representative"
                  type="text"
                  value={values.representative}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Column>
              <Column>
                  <strong>EMAIL</strong>
                  <input
                    id = "email"
                    name = "email"
                    type = "text"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
              </Column>
            </Row>
            <Row>
              <Column>
                  <strong>TELEFONE</strong>
                  <input
                    id = "phone"
                    name = "phone"
                    type = "text"
                    value = {values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
              </Column>
              <Column>
                  <strong>CELULAR</strong>
                  <input
                    id = "cell_phone"
                    name = "cell_phone"
                    type = "text"
                    value = {values.cell_phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
              </Column>
            </Row>
            <Row>
              <Column>
                  <strong>ENDEREÇO</strong>
                  <input
                    id = "address"
                    name = "address"
                    type = "text"
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
              </Column>
            </Row>
            <Row>
              <Column>
                  <strong>CIDADE</strong>
                  <input
                    id = "city"
                    name = "city"
                    type = "text"
                    value = {values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
              </Column>
              <Column>
                  <strong>BAIRRO</strong>
                  <input
                    id = "neighborhood"
                    name = "neighborhood"
                    type = "text"
                    value = {values.neighborhood}
                    onChange = {handleChange}
                    onBlur = {handleBlur}
                  />
              </Column>
            </Row>

            <Row>
              <Column>
                  <strong>CEP</strong>
                  <input
                    id = "zip_code"
                    name = "zip_code"
                    type = "text"
                    value = {values.zip_code}
                    onChange = {handleChange}
                    onBlur = {handleBlur}
                  />
              </Column>
              <Column>
                  <strong>UF</strong>
                  <input
                    id = "uf"
                    name = "uf"
                    type = "text"
                    value = {values.uf}
                    onChange = {handleChange}
                    onBlur = {handleBlur}
                  />
              </Column>
            </Row>
            <Row>
              <Column>
                <strong>OBSERVAÇÃO</strong>
                <textarea
                  id="observation"
                  name="observation"
                  value={values.observation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ resize: "vertical", width: "100%" }}
                />
              </Column>
            </Row>

            <Row>
              <div className="buttons-container">
                <button type="submit" disabled={isSubmitting}>
                  SALVAR
                </button>

                <button
                  type="button"
                  onClick={handleReset}
                  disabled={!dirty || isSubmitting}
                >
                  RESET
                </button>

                {partner && (
                  <>
                    <button type="button" onClick={onNew}>
                      LIMPAR
                    </button>

                    <button className="delete" type="button" onClick={onDelete}>
                      EXCLUIR
                    </button>
                  </>
                )}
              </div>
            </Row>
          </ul>

          <hr />

          <ul>
            <Row>
              <Column style={{ flex: 1 }}>
                <strong>FORNECEDOR OU CLIENTE</strong>
                <Select
                  styles={SelectStyled}
                  id="partner"
                  value={values.partner}
                  placeholder="Selecione um cliente"
                  onChange={selectedOption => {
                    setFieldValue('partner', selectedOption);
                    onEdit(selectedOption);
                  }}
                  isSearchable
                  options={partners}
                  getOptionLabel={item => {
                    
                    const regime = taxRegimes?.find(r => r.uuid === item.taxRegimeUuid);

                    return regime
                      ? `${item.name} | ${regime.code} - ${regime.description}`
                      : item.name;
                  }}
                  getOptionValue={item => item.uuid}
                  name="partner"
                  isLoading={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando clientes'}
                  noOptionsMessage={() => 'Não há clientes cadastrados'}
                />
              </Column>
              <Column
                style={{
                  flex: "0 0 120px",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end"
                }}
              >
                  <button type="button" onClick={handleExportExcel}>
                    EXCEL
                  </button>
              </Column>
            </Row>
          </ul>
        </FormStyled>
      )}
    </Formik>
  );
};

PartnerForm.propTypes = {
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      cnpj: PropTypes.string,
    })
  ),
  partner: PropTypes.shape({
    name: PropTypes.string,
    cnpj: PropTypes.string,
  }),
  onDelete: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

PartnerForm.defaultProps = {
  partners: [],
  partner: null,
};

export default PartnerForm;
